import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MATERIALS } from '../data/content';
import './Materials.css';

export default function Materials() {
  const { t, lang } = useLanguage();

  return (
    <section id="materials" className="section materials">
      <div className="container">
        <div className="section-head section-head--center">
          <span className="kicker">{t.materials.kicker}</span>
          <h2 className="section-title">{t.materials.title}</h2>
          <p className="materials__intro">{t.materials.intro}</p>
        </div>
        <div className="materials__grid">
          {MATERIALS.map((m) => (
            <div className="material-card" key={m.code}>
              <span className="material-card__code" dir="ltr">{m.code}</span>
              <span className="material-card__name">{lang === 'ar' ? m.ar : m.en}</span>
            </div>
          ))}
        </div>
        <p className="materials__note">{t.materials.note}</p>
      </div>
    </section>
  );
}
